<template>
    <div>
        <a-modal centered v-if="data.step == 'register'" :bodyStyle="{ padding: 0 }" :visible="visible" :closable="false" :footer="null">
            <!-- header -->
            <div class="custom-modal-header">
                <label class="custom-modal-header-title fs-16">
                    {{ $t('สมัคร') }}
                </label>
            </div>
            <div class="custom-modal-body">
                <label class="custom-modal-body-detail"> ยืนยันการสมัครกิจกรรม </label>
            </div>
            <!-- footer -->
            <div class="custom-modal-footer">
                <a-button key="back" class="text-center gray ant-button-label-custom" style="width: 50%" @click="cancel()">
                    {{ $t('ยกเลิก') }}
                </a-button>
                <a-button key="back" class="custom-modal-footer-single-confirm-btn" style="width: 50%" @click="create()">
                    {{ $t('ยืนยัน') }}
                </a-button>
            </div>
        </a-modal>
        <a-modal centered v-if="data.step == 'register_success'" :bodyStyle="{ padding: 0 }" :visible="visible" :closable="false" :footer="null">
            <div class="custom-modal-body">
                <label class="custom-modal-body-detail"> {{ data.message }} </label>
            </div>
            <!-- footer -->
            <div class="custom-modal-footer">
                <a-button key="back" class="custom-modal-footer-single-close-btn" @click="cancel()">
                    {{ $t('ปิดหน้าต่าง') }}
                </a-button>
            </div>
        </a-modal>
    </div>
</template>
<script>
export default {
    props: ['visible', 'data'],
    beforeCreate() {
        this.form = this.$form.createForm(this, { name: 'form_in_modal' });
    },
    data() {
        return {};
    },
    methods: {
        cancel() {
            this.$emit('on-cancel');
        },
        create() {
            this.$emit('on-save');
        },
    },
};
</script>
<style scoped>
.custom-modal-header {
    background: transparent;
    padding: 16px 10px;
    padding-bottom: 0;
    text-align: center;
}
.custom-modal-header-title {
    color: #141322 !important;
    font-weight: 600;
}
.custom-modal-body {
    background: transparent;
    padding: 16px 10px;
    padding-bottom: 0;
    text-align: center;
}
.custom-modal-body-detail {
    color: #141322 !important;
    font-size: 14px;
}
.custom-modal-footer {
    background: transparent;
    padding: 16px 10px;
}
.custom-modal-footer-single-confirm-btn {
    background: linear-gradient(0deg, #ff7105, #ff9500 100%) no-repeat;
    color: #fff;
    width: 50%;
}
.custom-modal-footer-single-close-btn {
    background: linear-gradient(0deg, #ff7105, #ff9500 100%) no-repeat;
    color: #fff;
    width: 100%;
}
</style>